import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Banner = () => {
  const slides = [
    {
      title: "Precision IT Solutions, Tailored for You",
      bg: "assets/img/hero/hero_bg_1_1.jpg",
    },
    {
      title: "Smart IT Consulting for Modern Businesses",
      bg: "assets/img/hero/hero_bg_1_2.jpg",
    },
    {
      title: "Your Trusted Partner in Tech & Strategy",
      bg: "assets/img/hero/hero_bg_1_3.jpg",
    },
  ];

  return (
    <div className="th-hero-wrapper hero-1" id="hero">
      <Swiper
        modules={[Navigation, Pagination]}
        navigation={{
          nextEl: '.slider-next',
          prevEl: '.slider-prev',
        }}
        pagination={{ el: '.slider-pagination', clickable: true }}
        loop={true}
        className="hero-slider-1"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="hero-inner">
              <div
                className="th-hero-bg"
                style={{
                  backgroundImage: `url(${slide.bg})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  height: '100%',
                  width: '100%',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  zIndex: -1,
                }}
              ></div>

              <div className="hero-1-shape d-none d-lg-block">
                <img src="assets/img/shape/hero-1-shape.png" alt="hero-shape" />
              </div>

              <div className="container">
                <div className="row">
                  <div className="col-xl-9 col-lg-8">
                    <div className="hero-style1">
                      <span className="sub-title style1">Dynamic IT, Dynamic Results.</span>
                      <h1 className="hero-title">{slide.title}</h1>
                      <p className="hero-text text-white">
                        Welcome to Avighna where we specialize in delivering tailored technology and IT solutions.
                      </p>
                      <div className="btn-group">
                        <Link to="/contact" className="th-btn style7 th-icon">
                          Discover More <i className="fa-light fa-arrow-right-long"></i>
                        </Link>
                        <Link to="/services" className="th-btn style2 th-icon">
                          Our Services <i className="fa-light fa-arrow-right-long"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Navigation arrows & pagination */}
      <div className="th-swiper-custom">
        <button className="slider-arrow slider-prev">
          <img src="assets/img/icon/right-arrow.svg" alt="prev" />
        </button>
        <div className="slider-pagination"></div>
        <button className="slider-arrow slider-next">
          <img src="assets/img/icon/left-arrow.svg" alt="next" />
        </button>
      </div>

      {/* Features section */}
      <section>
        <div className="feature-list-wrap">
          <div className="feature-area overflow-hidden" id="feature-area">
            <div className="row gx-0 justify-content-center">
              <div className="col-xl-4 col-lg-6">
                <div className="feature-item d-flex align-items-start">
                  <div className="feature-item_icon">
                    <img src="assets/img/icon/feature_1_1.svg" alt="icon" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title text-anime-style-2">Highly Expert Team</h3>
                    <p className="feature-item_text">We provide the most responsive and functional IT design</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6">
                <div className="feature-item d-flex align-items-start">
                  <div className="feature-item_icon">
                    <img src="assets/img/icon/feature_1_2.svg" alt="icon" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title text-anime-style-2">24/7 Customer Service</h3>
                    <p className="feature-item_text">We provide the most responsive and functional IT design</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6">
                <div className="feature-item d-flex align-items-start">
                  <div className="feature-item_icon">
                    <img src="assets/img/icon/feature_1_3.svg" alt="icon" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title text-anime-style-2">Competitive Pricing</h3>
                    <p className="feature-item_text">We provide the most responsive and functional IT design</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Banner;
